// ==============================|| SETTINGS OBJ READ HELPERS ||============================== //
// Lives under `utils/` so `merchantSlice` can read nested settings without importing `features/settings` (avoids cycles with `merchantSlice`).

function isMergeableRecord(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

/** Reads a nested value from merchant `settingsObj` using string path segments. */
export function getSettingsValueAtPath(root: unknown, path: readonly string[]): unknown {
  let current: unknown = root;
  for (const segment of path) {
    if (!isMergeableRecord(current)) {
      return undefined;
    }
    current = current[segment];
  }
  return current;
}
